export default function () {
    return (
        <>
            <b>END USER LICENSE AGREEMENT (EULA)</b>
            <p>
                PLEASE READ THIS END USER LICENSE AGREEMENT (“AGREEMENT”) CAREFULLY BEFORE USING THE RAS REVIEW THE WEB-BASED ENGINEERING APPLICATION (THE “APPLICATION”). BY USING THE APPLICATION, YOU ARE AGREEING TO BE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, DO NOT USE THE APPLICATION.
            </p>

            <b>License Grant</b>
            <p>
                Subject to the terms of this Agreement, the Application is licensed, not sold, to you for use only under the terms of this Agreement. The Application is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties.
            </p>

            <b>Use of the Application</b>
            <p>
                You may use the Application solely for your personal or internal business purposes. You may not use the Application for any illegal or unauthorized purpose or in any manner that violates any applicable laws or regulations. You agree not to use or attempt to use the Application to violate the security of any network, service, or other system. You agree not to modify, adapt, translate, reverse engineer, decompile, or disassemble the Application or otherwise attempt to derive its source code.
            </p>

            <b>Ownership</b>
            <p>
                The Application and all intellectual property rights therein are owned by the licensor and are protected by applicable intellectual property laws. This Agreement does not grant you any rights to the Application or its intellectual property except as expressly set forth herein.
            </p>

            <b>Privacy and Personal Information</b>
            <p>
                We collect and process your personal information and usage data to provide and secure the Service. For detailed information regarding how your data is handled, stored, and protected, please review our full <a href="/app/privacy" target="_blank" style={{textDecoration: 'none'}}>Privacy Policy</a>, which is incorporated into these Terms by reference.
            </p>

            <b>Fees and Payment</b>
            <p>
                You agree to pay all fees and charges related to your use of the Application. The licensor reserves the right to modify its fees and payment policies at any time.
            </p>

            <b>Termination</b>
            <p>
                This Agreement will terminate automatically if you breach any of its terms. Upon termination, you must immediately cease all use of the Application and destroy all copies of the Application in your possession.
            </p>

            <b>Disclaimer of Warranties</b>
            <p>
                THE APPLICATION IS PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
            </p>

            <b>Limitation of Liability</b>
            <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE LICENSOR BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF BUSINESS INFORMATION, OR ANY OTHER PECUNIARY LOSS) ARISING OUT OF THE USE OF OR INABILITY TO USE THE APPLICATION, EVEN IF THE LICENSOR HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>

            <b>Indemnification</b>
            <p>
                You agree to indemnify and hold the licensor and its affiliates, officers, agents, and employees harmless from any claim or demand, including reasonable attorneys’ fees, made by any third party due to or arising out of your breach of this Agreement, your violation of any law or the rights of a third party, or your use of the Application.
            </p>

            <b>Governing Law</b>
            <p>
                This Agreement shall be governed by and construed in accordance with the laws of the jurisdiction in which the licensor is located, without giving effect to its conflict of laws provisions.
            </p>

            <b>Entire Agreement</b>
            <p>
                This Agreement constitutes the entire agreement between you and the licensor with respect to the Application and supersedes all prior or contemporaneous communications and proposals, whether oral or written, between you and the licensor.
            </p>

            <b>Modification</b>
            <p>
                The licensor may modify this Agreement at any time by posting a revised version on its website or by providing notice to you. Your continued use of the Application after any such modification constitutes your acceptance of the modified Agreement.
            </p>

            <b>Contact Information</b>
            <p>
                If you have any questions about this Agreement or the Application, please contact the licensor at <a href="mailto:support@rasreview.com" style={{textDecoration: 'none'}}>support@rasreview.com</a>
            </p>
            <p>
                By clicking “I Agree” or using the Application, you acknowledge that you have read and agree to be bound by the terms and conditions of this Agreement. If you do not agree to the terms and conditions of this Agreement, do not use the Application.
            </p>
        </>
    )
}